export const REVIEW_STATUS = {
  APPROVED: 1,
  PENDING: 2,
};

export const REVIEW_STORE_ID = {
  MOBILE: 5,
  DESKTOP: 4,
};

export const GET_NPS_PRESIGNED_URL_REQUEST_PATH = '/npsmail/products/reviews/images/url';
export const GET_NPS_REVIEWS_REQUEST_PATH = '/npsmail/products/reviews';

export const GET_PRESIGNED_URL_REQUEST_PATH = '/products/reviews/images/url';
export const GET_REVIEWS_REQUEST_PATH = '/products/reviews';
